/**
 * Created by Jerker Nord on 2021-01-28.
 */
import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {SimplePresentationRunner} from "../../core/winpresentation/SimplePresentationRunner";
import {BenjiKIV} from "../BenjiKIV";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {BenjiKIVGameMode} from "../server/BenjiKIVGameMode";

export class BenjiKIVIdleNormalPresentation implements FlowStatePresentation {
    constructor() {

    }

    public start(flowStateController: FlowStateController): void {
        // #260
        BenjiKIV.xBetView.hasBetPlaced = false;

        if (!BenjiKIV.autoPlayPlugin.isAutoplayRound) {
            BenjiKIV.xBetView.enableButtons(true);
        } else {
            BenjiKIV.xBetView.tryBlueXBetReelOverlay();
        }

        // #5
        if (!BenjiKIV.isWinBelowPlayedBetValue() && !BenjiKIV.isActionSpinsActive) {
            BenjiKIV.individualWin.start();
        }

        SimplePresentationRunner.run([], () => this.complete(flowStateController), (callback?: Function) => flowStateController.setSkipCallback(callback));
    }

    private complete(flowStateController: FlowStateController): void {
        const wasBonus: boolean = BenjiKIV.model.gameData && BenjiKIV.model.gameData.mode.indexOf("FREESPIN") > -1 && BenjiKIV.model.gameData.nextMode == BenjiKIVGameMode.NORMAL;
        if (wasBonus) {
            // NolimitApplication.events.trigger(ActionSpinHandler.ON_BONUS_COMPLETE_EVENT);
        }
        flowStateController.finish();
    }
}